export default __webpack_public_path__ + "static/media/LogoMUHN2019.d124a78d.png";